





































import {Component, Vue} from 'vue-property-decorator'
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import ErrorPreviewDialog from "@/components/Dialog/ErrorPreviewDialog.vue";
import MenusStore from '@/store/modules/MenusStore';
import DeliousItemsStore from '@/_common/api/store/modules/DeliousItemsStore';
import StoresStore from '@/store/modules/StoresStore';
import GenerationsStore from '@/store/modules/GenerationsStore';

@Component({
    components: {
        ErrorPreviewDialog,
    },
})
export default class MenuTopNavi extends Vue {
    private isErrorPreview = false;

    get firstCategory(): number {
        return CategoriesStore.firstCategoryId;
    }

    private async onClickMenuItem() {
        const menuId: number = Number(this.$route.params.menuId);
        const storeId: number = MenusStore.menuById[menuId].store_ids ? Number(MenusStore.menuById[menuId].store_ids[0]) : Number(StoresStore.all[0].code);
        await DeliousItemsStore.init({storeId: storeId, periodId: GenerationsStore.selected.period_no});

        const params = { menuId: this.$route.params.menuId, categoryId: String(CategoriesStore.firstCategoryId)};
        await this.$router.push({name: 'menu_item', params: params}, () => {});
    }

    private async onClickMenuDesign() {
        const menuId: number = Number(this.$route.params.menuId);
        const storeId: number = MenusStore.menuById[menuId].store_ids ? Number(MenusStore.menuById[menuId].store_ids[0]) : Number(StoresStore.all[0].code);
        await DeliousItemsStore.init({storeId: storeId, periodId: GenerationsStore.selected.period_no});
        await this.$router.push({name: 'menu_design_nav', params: { menuId: this.$route.params.menuId}}, () => {});
    }

    private onClickPreview(): void {
        if (CategoriesStore.all.length > 0) {
            let routeData = this.$router.resolve({name:'preview', params:{menuId:this.$route.params.menuId}});
            window.open(routeData.href, '_blank');
        } else {
            this.isErrorPreview = true;
        }
    }

    private onCloseErrorPreview(): void {
        this.isErrorPreview = false;
    }

}
